export default {
  title: 'Регионы стран',

  titles: {
    create: 'Создать регион'
  },

  labels: {
    region: 'Регион',
    country: 'Страна',
    regionCode: 'Код региона',
    regionName: 'Название региона',
    countryCode: 'Код страны',
    countryName: 'Название страны',
    timeZone: 'Часовой пояс'
  },

  rules: {
    length: {
      range: 'Длина от {minLength} до {maxLength} символов',
      exact: 'Длина в символах: {maxLength}'
    },

    pattern: {
      regionCode: 'Латинские буквы и цифры',
      regionName: 'Русские и латинские буквы, цифры, пробел, апостроф и дефис',
      countryCode: 'Заглавные латинские буквы',
      countryName: 'Русские и латинские буквы, пробел, апостроф и дефис',
      timeZone: 'Формат UTC+HH:MM или UTC-HH:MM'
    }
  },

  infos: {
    form: '<b>Код региона</b> - внутри страны, например 77 или CA.<br><b>Название региона</b> - например Москва.<br><b>Код страны</b> - двухбуквенный код, например RU.<br><b>Название страны</b> - например Россия.<br><b>Часовой пояс</b> - смещение от UTC, например UTC+03:00.'
  },

  warnings: {
    form: 'Пара <b>код страны</b> и <b>код региона</b> должна быть уникальной.'
  },

  snackbars: {
    created: 'Регион успешно создан.',
    updated: 'Регион успешно обновлён.',
    removed: 'Регион успешно удалён.'
  }
}
